/* Vue & App Component */
import Vue from 'vue';
import App from '../HomepageApp.vue';

/* Plugins */
import vuetify from './plugins/vuetify.js';
import './plugins/icons.js';
import router from './router.js';

/* App modules */
import VueConfetti from 'vue-confetti';

Vue.config.productionTip = false;

Vue.use(VueConfetti);

new Vue({
	render: h => h(App),
	vuetify,
	router
}).$mount('#app');
